/**
 * @file Map.repository.ts
 * @module MapRepository
 * @description Reaktīvā stāvokļa krātuve OpenLayers kartes instancei (izmanto @ngneat/elf).
 *              Nodrošina vienīgo (singleton) kartes atsauci, ko visi Karšu pārlūka
 *              komponenti var abonēt caur getMapStore(). Tiek atjaunināta kartes
 *              inicializācijas laikā.
 */

import { createStore, select, setProp, withProps } from "@ngneat/elf";
import { Map } from "ol";

/** State shape for the map store */
export interface MapStoreProps {
  /** The current OpenLayers Map instance (undefined before initialization) */
  map?: Map;
}

const mapStore = createStore({ name: "map" }, withProps<MapStoreProps>({}));

/**
 * Returns an observable of the map store state.
 * Subscribe to get notified when the map instance changes.
 *
 * @returns {Observable<MapStoreProps>} Observable emitting the current map state
 */
export function getMapStore() {
  return mapStore.pipe(select((state) => state));
}

/**
 * Updates the map store with new property values.
 * Iterates over provided keys and updates each property individually.
 *
 * @param {MapStoreProps} props - Properties to update (e.g., { map: mapInstance })
 */
export function updateMapStore(props: MapStoreProps) {
  for (const key in props) {
    if (Object.prototype.hasOwnProperty.call(props, key)) {
      mapStore.update(setProp(key as keyof MapStoreProps, (props as any)[key]));
    }
  }
}
